import { defaultApiState } from '../api.state';

export const latestVideoMutations = {
  GET_LATEST_VIDEOS_LOADING(state) {
    state.apiState.getLatestVideos = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_LATEST_VIDEOS_SUCCESS(state, payload) {
    state.apiState.getLatestVideos = {
      ...defaultApiState,
      success: true,
    };
    state.latestVideos = payload;
  },
  GET_LATEST_VIDEOS_ERROR(state, error) {
    state.apiState.getLatestVideos = {
      ...defaultApiState,
      error,
    };
  },

  ADD_LATEST_VIDEO_LOADING(state) {
    state.apiState.addLatestVideo = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_LATEST_VIDEO_SUCCESS(state) {
    state.apiState.addLatestVideo = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_LATEST_VIDEO_ERROR(state, error) {
    state.apiState.addLatestVideo = {
      ...defaultApiState,
      error,
    };
  },

  GET_LATEST_VIDEO_RESET(state) {
    state.apiState.getLatestVideo = {
      ...defaultApiState,
    };
    state.latestVideo = undefined;
  },
  GET_LATEST_VIDEO_LOADING(state) {
    state.apiState.getLatestVideo = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_LATEST_VIDEO_SUCCESS(state, payload) {
    state.apiState.getLatestVideo = {
      ...defaultApiState,
      success: true,
    };
    state.latestVideo = payload;
  },
  GET_LATEST_VIDEO_ERROR(state, error) {
    state.apiState.getLatestVideo = {
      ...defaultApiState,
      error,
    };
  },

  UPDATE_LATEST_VIDEO_LOADING(state) {
    state.apiState.updateLatestVideo = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_LATEST_VIDEO_SUCCESS(state) {
    state.apiState.updateLatestVideo = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_LATEST_VIDEO_ERROR(state, error) {
    state.apiState.updateLatestVideo = {
      ...defaultApiState,
      error,
    };
  },

  DELETE_LATEST_VIDEO_LOADING(state) {
    state.apiState.deleteFaq = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_LATEST_VIDEO_SUCCESS(state, payload) {
    state.apiState.deleteFaq = {
      ...defaultApiState,
      success: true,
    };
    state.latestVideos = state.latestVideos.filter(o => o.id !== payload.id);
  },
  DELETE_LATEST_VIDEO_ERROR(state, error) {
    state.apiState.deleteFaq = {
      ...defaultApiState,
      error,
    };
  },
};
